import api from "@/lib/api";
import { IApiResponse, Record } from "@/@types/lib/api/api";

// Types
import { ActivateData } from "@/@types/services/authService";
import { AnonymizeData, DeactivateData, IUserService, PasswordSetData, SetSettingsData, HPSSyncData } from "@/@types/services/userService";
import { IUserSettings } from "@/@types/common";

export const userService: IUserService = {
  activate,
  deactivate,
  anonymize,
  setUserSettings,
  setPassword,
  hpsSync
};

const userApiUrl = "users/";

function activate(id: number): Promise<ActivateData> {
  const apiInstance = new api();
  const url = `${userApiUrl}${id.toString()}/activate`;

  return apiInstance.Call(url, "patch");
}

function deactivate(id: number): Promise<DeactivateData> {
  const apiInstance = new api();
  const url = `${userApiUrl}${id.toString()}/deactivate`;

  return apiInstance.Call(url, "patch");
}

function anonymize(id: number): Promise<AnonymizeData> {
  const apiInstance = new api();
  const url = `${userApiUrl}${id.toString()}/anonymize`;

  return apiInstance.Call(url, "patch");
}

function hpsSync(id: number): Promise<HPSSyncData> {
   const apiInstance= new api();
  const url = `${userApiUrl}${id.toString()}/hps-sync`;

   return apiInstance.Call(url, "patch");
}

function setUserSettings(id: number, settings: IUserSettings): Promise<SetSettingsData> {
  const apiInstance = new api();
  const url = `${userApiUrl}${id.toString()}/set-settings`;

  return apiInstance.Call(url, "put", settings);
}

function setPassword(id: number, password_new: string): Promise<PasswordSetData> {
  const apiInstance = new api();
  const url = `${userApiUrl}${id.toString()}/set-password`;

  const bodyData = {
    password: password_new
  }

  return apiInstance.Call(url, "patch", bodyData)
}